export default __webpack_public_path__ + "static/media/IN_PROGRESS.f734cfa2.svg";